import { Link } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SEOHead } from "@/components/SEOHead";
import { useLanguage } from "@/lib/i18n";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useEffect } from "react";

const BASE_URL = 'https://pdrn-skin.com';

interface LegalPageLayoutProps {
  titleKey: string;
  seoDescriptionKey: string;
  pagePath: string;
  children: React.ReactNode;
}

export function LegalPageLayout({ titleKey, seoDescriptionKey, pagePath, children }: LegalPageLayoutProps) {
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const pageTitle = t(titleKey);
  const fullUrl = `${BASE_URL}${pagePath}`;

  const breadcrumbs = [
    { name: t('nav.home'), url: BASE_URL },
    { name: pageTitle },
  ];

  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title={`${pageTitle} | PDRN SKIN`}
        description={t(seoDescriptionKey)}
        url={fullUrl}
        breadcrumbs={breadcrumbs}
        dateModified="2026-02-10"
        speakableSelectors={['.legal-heading', '.legal-content']}
      />
      <Header />

      <main className="container py-12 md:py-20">
        <div className="max-w-3xl mx-auto">
          <Button variant="ghost" size="sm" asChild className="mb-8">
            <Link to="/">
              <ArrowLeft className="w-4 h-4 me-2" />
              {t('legal.backHome')}
            </Link>
          </Button>

          <article className="bg-card rounded-2xl border border-border/50 shadow-sm p-6 md:p-10">
            {children}
          </article>

          <div className="mt-8 text-center">
            <Button variant="outline" asChild>
              <Link to="/">
                <ArrowLeft className="w-4 h-4 me-2" />
                {t('legal.backHome')}
              </Link>
            </Button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
